import { baseApi } from "../baseApi";
export const careGiverApi = baseApi.injectEndpoints({
  tagTypes: ['CgPatients', 'CgRqeuests'],
  endpoints: (builder) => ({
    getCareGiver: builder.query({
      query: (params) => {
        return {
          url: `/caregivers/list_patient.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
      providesTags: ['CgPatients'],
    }),
    getCgRequests: builder.query({
      query: (params) => {
        return {
          url: `/caregivers/pending_request.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
      providesTags: ['CgRqeuests'],
    }),
    acceptCgRequest: builder.mutation({
      query: (body) => {
        return {
          url: `/caregivers/approve.json`,
          method: "POST",
          body: body,
        };
      },
      invalidatesTags: ['CgPatients', 'CgRqeuests'],
    }),
    rejectCgRequest: builder.mutation({
      query: (body) => {
        return {
          url: `/caregivers/reject.json`,
          method: "POST",
          body: body,
        };
      },
      invalidatesTags: ['CgPatients', 'CgRqeuests'],
    }),
    getCaregiverRights: builder.query({
      query: (params) => {
        return {
          url: `/caregivers/select_patient.json`,
          method: "GET",
          params: params,
        };
      },
    })
    
  }),
});

// Export hooks for usage in functional components
export const { useGetCareGiverQuery, useGetCgRequestsQuery, useAcceptCgRequestMutation, useRejectCgRequestMutation } = careGiverApi;
